import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { destinations } from '../../../mocks/destinations';

export default function Destinations() {
  const { t } = useTranslation();
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  return (
    <section id="destinos" className="py-16 md:py-32 px-4 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-12 md:mb-16 gap-6">
          <div>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
              {t('dest_title')}
            </h2>
            <div className="w-20 h-1 bg-teal-600"></div>
          </div>
          <p className="text-base md:text-lg text-gray-600 md:max-w-xl md:text-right leading-relaxed">
            {t('dest_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {destinations.map((destination) => (
            <div
              key={destination.id}
              className="group relative overflow-hidden rounded-3xl cursor-pointer"
              onMouseEnter={() => setHoveredId(destination.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="relative w-full h-80">
                <img
                  src={destination.image}
                  alt={destination.name}
                  className={`w-full h-full object-cover transition-transform duration-500 ${
                    hoveredId === destination.id ? 'scale-105' : 'scale-100'
                  }`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                <span className="absolute top-4 right-4 px-4 py-2 bg-white/90 backdrop-blur-sm text-teal-700 text-xs font-semibold rounded-full">
                  {destination.category}
                </span>

                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-2xl font-bold text-white mb-2">{destination.name}</h3>
                  <div className="flex items-center text-white/90 text-sm">
                    <i className="ri-map-pin-line mr-2"></i>
                    <span>{destination.location}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}